import appService from 'src/pl.service';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      dmqData: [],
      displayedDmqItem: null,
      selected: -1,
      statusDetails: [],
      displayedDmqItems: [],
      perPage: 7,
      currentPage: 1,
      totalRows: 0,
      activeRow: 'Total',
      fields: ['name', 'count', 'clear_transactions'],
      isBusy: true,
      removeHovered: false,
      pendingDmqId: -1,
      selectedPayor: 'All',
      undoArray: [],
      searchFilter: "",
      clearModal: {name : ""},
      companies: [],
      selectedCompany: -1,
      skip: 0,
      payorOptions: []
    };
  },
  watch: {
    selectedCompany: function(newVal){
      this.resetData();
      this.loadData(newVal);
      this.loadStatuses();
      this.loadPayors();
    },
    selectedPayor: function()
    {
      this.loadData(this.selectedCompany)
    },
    currentPage(newPage) {
      console.log("page change", newPage)
      this.currentPage = newPage;
      this.skip = (newPage - 1) * this.perPage
      this.loadData(this.selectedCompany);
    }
  },
  computed: {
    ...mapState({
      loggedInApplicantId: state => state.applicant.applicantId,
    }),
  },
  methods: {
    onPageChange(newPage) {
      this.currentPage = newPage;
      this.loadData(this.selectedCompany);
    },
    async loadStatuses() {
      this.statusDetails = [];
      var statuses = await appService.getDeductibleMonitoringItemStatuses(this.selectedCompany);
      for(let i = 0; i < statuses.length; i++)
      {
        this.statusDetails.push({
          name: statuses[i].status,
          clear_transactions: statuses[i] !== 'Deductible Met',
          count: statuses[i].count
        })
      }

      this.statusDetails.push({
        name: 'Total',
        count: statuses.reduce((sum, item) => sum + item.count, 0)
      });
    },
    async loadPayors() {
      this.payorOptions = await appService.getDeductibleMonitoringPayors(this.selectedCompany);
      this.payorOptions.unshift("All");
    },
    async loadData(companyId) {

      //this.isBusy = true;
      let statusFilter = this.activeRow != 'Total' ? this.activeRow : '';
      this.dmqData = await appService.getDeductibleMonitoringItems(companyId, this.skip, this.perPage, this.selectedPayor, this.searchFilter, statusFilter);
      this.totalRows = await appService.getDeductibleMonitoringItemCount(companyId, this.selectedPayor, this.searchFilter, statusFilter);
      this.displayedDmqItems = this.dmqData;

      console.log('loadData', this.displayedDmqItems);
      console.log('total items', this.totalRows);

      let distinctPayors = Array.from(new Set(this.dmqData.map((item) => item.payorName)));

      // Set up the payorOptions based on the distinct Payors that we found in the return
      for(let p = 0; p < distinctPayors.length; p++){
        // Initialize if needed
        if(!this.payorOptions) this.payorOptions = [];

        if (this.payorOptions.findIndex(x => x === distinctPayors[p]) < 0){
          this.payorOptions.push(distinctPayors[p]);
        }

      }

      

      // Navigate to the applicant based on loggedInApplicantId, OR go to the first item in the list
      await this.selectLoggedInOrFirst();

      this.isBusy = false;
    },
    resetData(){
      this.totalRows = 1;
      this.dmqData = [];
      this.displayedDmqItems = [];
      this.displayedDmqItem = null;
      this.statusDetails = [];
    },
    updateDisplay(dmqItem) {
      // If no applicant data was found for this record, remove it from the view
      if(!dmqItem){
        this.selected = -1
        this.displayedDmqItem = null;
      }

      if (!this.removeHovered) {
        this.selected = dmqItem.deductibleManagementQueueId;
        this.displayedDmqItem = dmqItem;
      }
    },
    get30Url(patientId) {
      return window.location.origin + '/fullpatientData/' + patientId;
    },
    confirmPendingReview() {
      this.removeFromView(this.pendingDmqId, 'Pending');
      this.$root.$emit('bv::hide::modal', 'pending-review-modal');
    },
    undoFinishReview(undoDmqItem = null) {
      //adjust the counts on the overview board
      //Undo will send a message with id and reviewed set to false
      if (this.undoArray.length) {
        var dmqItem = null;
        if (undoDmqItem) {
          dmqItem = undoDmqItem;
          this.undoArray = this.undoArray.filter(
            d =>
              d.deductibleManagementQueueId !=
              undoDmqItem.deductibleManagementQueueId
          );
        } else {
          dmqItem = this.undoArray.pop();
        }
        var id = dmqItem.deductibleManagementQueueId;
        appService.setDMQItemAsReviewed(id, false);
        console.log(this.undoArray.length);
        var status = dmqItem.completedStatus;
        this.dmqData.push(dmqItem);
        //Will add it back to dmqData (and need to sort)
        this.dmqData.sort(function(a, b) {
          var n1 = a.firstname + '_' + a.lastname;
          var n2 = b.firstname + '_' + b.lastname;
          if (n1 > n2) return 1;
          else if (n1 < n2) return -1;
          return 0;
        });

/*        if (status === this.activeRow) {
          this.displayedDmqItems.push(dmqItem);
          this.displayedDmqItems.sort(function(a, b) {
            var n1 = a.firstname + '_' + a.lastname;
            var n2 = b.firstname + '_' + b.lastname;
            if (n1 > n2) return 1;
            else if (n1 < n2) return -1;
            return 0;
          });
        } else if (this.activeRow === 'Total') {
          //If it was on total add it to the displayedItems will
          //add a duplicate because the array is assigned via reference
          this.displayedDmqItems = this.dmqData;
        }*/
        this.statusDetails.find(x => x.name === status).count++;
        this.statusDetails.find(x => x.name === 'Total').count++;

        this.displaySuccessToast('Undo Successful');
      }
    },
    async removeFromView(dmqId) {
      let dmqItem = this.dmqData.find(item => item.deductibleManagementQueueId == dmqId);
      var id = dmqItem.deductibleManagementQueueId ?? this.pendingDmqId;
      var status = dmqItem.completedStatus;
      appService.setDMQItemAsReviewed(id, true);
      this.undoArray.push(dmqItem);
      //clear the currently selected and remove the item from all saved arrays
      if (
        this.displayedDmqItem &&
        this.displayedDmqItem.deductibleManagementQueueId === id
      ) {
        this.displayedDmqItem = null;
        this.selected = -1;
      }

      this.dmqData = this.dmqData.filter(
        d => d.deductibleManagementQueueId != id
      );
      this.displayedDmqItems = this.displayedDmqItems.filter(
        d => d.deductibleManagementQueueId != id
      );
      //remove 1 from the count of the items status
      this.statusDetails.find(x => x.name === status).count--;
      this.statusDetails.find(x => x.name === 'Total').count--;
    },
    isSelected(i) {
      return i === this.selected;
    },
    getMoneyValue(moneyDecimal) {
      return (Math.round(moneyDecimal * 100) / 100).toFixed(2);
    },
    getDate(dateVal) {
      if (dateVal) {
        if (dateVal.indexOf('T') === -1) {
          dateVal = dateVal + 'T00:00:00.000';
        }
        var date = new Date(dateVal);
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDate();
        return zeroPad(month) + '/' + zeroPad(day) + '/' + year;
      }
      return '';

      function zeroPad(numVal) {
        if (numVal < 10) {
          return '0' + numVal;
        }
        return numVal;
      }
    },
    statusDetailsClicked(item) {
      var name = item.name;
      if (name != this.activeRow) {
        this.selectedPayor = 'All';
        this.displayedDmqItem = null;
        this.selected = -1;
        this.currentPage = 1;
        this.activeRow = name;
        this.loadData(this.selectedCompany)
      }
    },
    detailsIsActive(item, type) {
      if (!item || type !== 'row') return;
      if (item.name === this.activeRow)
        return 'overview-currently-selected table-success details-row-class';
      else return 'details-row-class';
    },
    filterItems() {
      this.loadData(this.selectedCompany);
    },
    async selectItem(deductibleManagementQueueId){
      console.log("selected item", deductibleManagementQueueId)
      let item = await appService.getDeductibleMonitoringItem(deductibleManagementQueueId, this.selectedCompany);
      this.updateDisplay(item);
    },
    async selectLoggedInOrFirst() {
      if (this.displayedDmqItems.length > 0) {
        let loggedInApplicant = this.displayedDmqItems.find(
          item => item.applicantId === this.loggedInApplicantId
        );
        
        // If the logged in applicant is in the list, go get the data from the server for the display item
        if (loggedInApplicant) {
          
          // Get the applicant data and update the display
          await this.selectItem(loggedInApplicant.deductibleManagementQueueId);
          
          // Get the index from the list and set the current page within the pagination control
          let loggedInIndex = this.displayedDmqItems.indexOf(loggedInApplicant);
          this.currentPage = parseInt(
            (loggedInIndex + 1) / this.perPage + 1,
            10
          );
          console.log('selectLoggedInOrFirst current page:', this.currentPage);
        } else {
          var firstId = this.displayedDmqItems[0].deductibleManagementQueueId;
          await this.selectItem(firstId);
        }
      }
    },
    async clearAllTransactions() {
      await appService.clearDeductibleMonitoringStatus(this.selectedCompany, this.clearModal.name)
      this.loadStatuses();
    },
    async clearAllModal(name, button) {
      this.clearModal.name = name;
      this.$root.$emit('bv::show::modal', 'clear-all-modal', button);
    },
    async init() {
      
      // Load the companies and map to something the ui can understand
      let companySelector = await appService.getCompanyPicker();

      this.companies = companySelector.companies.map(company => {
        return {
          value: company.companyId,
          text: company.companyName
        }
      });

      // Set the selectedCompany and let the watcher load the data
      this.selectedCompany = companySelector.defaultCompanyId;
    }
  },

  async created() {
    await this.init();
  },
};
